import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Forschungsprojekt')

export default {
  label: 'Forschungsprojekt',
  route: 'forschungsprojekt',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.Number('berichtsjahr', 'calendar-o'),
    Filter.ReferenceByMultiValueSearchRep('beteiligte', 'user', 'abstractPerson'),
    Filter.String('titelDE'),
    Filter.String('titelEN'),
    Filter.ReferenceByMultiValueSearchRep('antragsteller', 'user', 'abstractPerson'),
    Filter.ReferenceByMultiValueSearchRep('projektleiter', 'user', 'abstractPerson'),
    Filter.ReferenceBySearchRep('mittelgeber', 'credit-card', 'mittelgeber'),
    Filter.String('uebergeordnetesProjekt')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/ForschungsprojektFilter.js